<script setup>
import { useAttrs } from 'vue';
import { ONSEASON_BRAND } from 'onseason/config';

const attrs = useAttrs();
const onseasonBrand = ONSEASON_BRAND;
</script>

<template>
  <img
    v-bind="attrs"
    class="onseason-dashboard-logo"
    :src="onseasonBrand.assets.icon"
    alt="OnSeason"
  />
</template>
